/**
 * HEW³ 设计令牌 —— 唯一事实来源。
 *
 * 这些值从原型的 assets/theme.css 中原样抽取，保证新工程与原型的视觉完全一致。
 * 前端把 themeTokensCss() 注入 :root，图表引擎用 resolveColor() 把语义键
 * （'h' | 'e' | 'w' | 'x' …）解析为具体颜色，从而修掉原型里「数据层硬编码
 * var(--h) / #9B8CFF」导致换肤不联动的问题。
 */
export const themeTokens = {
    // 背景层次
    bg: '#05080F',
    bg2: '#0A1020',
    panel: '#0F1729',
    panel2: '#141E33',
    panel3: '#1B2740',
    // 描边
    line: 'rgba(255,255,255,.075)',
    line2: 'rgba(255,255,255,.15)',
    // 文字
    text: '#E9EEF9',
    text2: '#B7C2D8',
    muted: '#7F8DA7',
    muted2: '#5A6579',
    // 三螺旋语义色
    h: '#2FE3B0',
    h2: '#0EA47F',
    hSoft: 'rgba(47,227,176,.13)',
    e: '#5B92FF',
    e2: '#2C5FE0',
    eSoft: 'rgba(91,146,255,.13)',
    w: '#EBCB7A',
    w2: '#C39A33',
    wSoft: 'rgba(235,203,122,.13)',
    // 第四个语义色：原型里以字面量 #9B8CFF 散落在数据层，此处正式收编为令牌
    x: '#9B8CFF',
    xSoft: 'rgba(155,140,255,.13)',
    // 状态色
    ok: '#2FE3B0',
    warn: '#FFB020',
    danger: '#FF5D7E',
    info: '#48C8FF',
    // 圆角
    rS: '10px',
    r: '14px',
    rL: '20px',
    rXl: '26px',
};
/** 语义键 → CSS 颜色值。图表引擎与内联样式统一走这里。 */
export function resolveColor(key) {
    const map = {
        h: themeTokens.h,
        e: themeTokens.e,
        w: themeTokens.w,
        x: themeTokens.x,
        ok: themeTokens.ok,
        warn: themeTokens.warn,
        danger: themeTokens.danger,
        info: themeTokens.info,
        muted: themeTokens.muted,
    };
    return map[key] ?? key;
}
/** 允许出现在数据层里的语义色键，用于校验。 */
export const themeColorKeys = ['h', 'e', 'w', 'x', 'ok', 'warn', 'danger', 'info', 'muted'];
/** 生成注入 :root 的 CSS 变量块，变量名与原型 theme.css 保持一致。 */
export function themeTokensCss(selector = ':root') {
    const lines = [
        `--bg:${themeTokens.bg}`,
        `--bg-2:${themeTokens.bg2}`,
        `--panel:${themeTokens.panel}`,
        `--panel-2:${themeTokens.panel2}`,
        `--panel-3:${themeTokens.panel3}`,
        `--line:${themeTokens.line}`,
        `--line-2:${themeTokens.line2}`,
        `--text:${themeTokens.text}`,
        `--text-2:${themeTokens.text2}`,
        `--muted:${themeTokens.muted}`,
        `--muted-2:${themeTokens.muted2}`,
        `--h:${themeTokens.h}`,
        `--h-2:${themeTokens.h2}`,
        `--h-soft:${themeTokens.hSoft}`,
        `--e:${themeTokens.e}`,
        `--e-2:${themeTokens.e2}`,
        `--e-soft:${themeTokens.eSoft}`,
        `--w:${themeTokens.w}`,
        `--w-2:${themeTokens.w2}`,
        `--w-soft:${themeTokens.wSoft}`,
        `--x:${themeTokens.x}`,
        `--x-soft:${themeTokens.xSoft}`,
        `--ok:${themeTokens.ok}`,
        `--warn:${themeTokens.warn}`,
        `--danger:${themeTokens.danger}`,
        `--info:${themeTokens.info}`,
        `--r-s:${themeTokens.rS}`,
        `--r:${themeTokens.r}`,
        `--r-l:${themeTokens.rL}`,
        `--r-xl:${themeTokens.rXl}`,
        `--font:-apple-system,BlinkMacSystemFont,"PingFang SC","HarmonyOS Sans SC","Microsoft YaHei",system-ui,sans-serif`,
        `--num:"Bahnschrift","DIN Alternate","Helvetica Neue",system-ui,sans-serif`,
    ];
    return `${selector}{${lines.join(';')}}`;
}
//# sourceMappingURL=theme.js.map